import warningIcon from "images/warning.svg";
import criticalIcon from "images/critical.svg";
import noticeIcon from "images/notice.svg";
import errorIcon from "images/error.svg";
import infoIcon from "images/info.svg";
import promotionIcon from "images/promotion.svg";

export const getNotificationdataMeta = (item = {}) => {
  const severityMap = {
    critical: { label: "Critical", icon: criticalIcon },
    error: { label: "Error", icon: errorIcon },
    notice: { label: "Notice", icon: noticeIcon },
    info: { label: "Information", icon: infoIcon },
    informational: { label: "Information", icon: infoIcon },
    warning: { label: "Warning", icon: warningIcon }
  };

  let itemMeta = severityMap[item.severity] || severityMap.warning;

  if (item.category === "promotion") {
    itemMeta = {
      ...itemMeta,
      label: "Promotion",
      icon: promotionIcon,
    };
  } else if (item.category === "recommendation") {
    itemMeta = {
      ...itemMeta,
      label: "Recommendation",
      icon: infoIcon,
    };
  }

  return itemMeta;
};

export const getTopNotificationByChannel = (data, channel) => {
  const now = Math.floor(Date.now() / 1000);
  if (!Array.isArray(data) || !data.length) return null;

  const filtered = data.filter(
    (item) => item.channels?.[channel] && item.channels[channel].expiry >= now
  );
  if (!filtered.length) return null;

  const sorted = [...filtered].sort((a, b) => {
    const priorityA = a.priority ?? 99;
    const priorityB = b.priority ?? 99;
    if (priorityA !== priorityB) return priorityA - priorityB;

    const timeA = a.resolved ?? a.timestamp;
    const timeB = b.resolved ?? b.timestamp;
    return timeB - timeA;
  });

  return sorted[0];
};

export const getNotificationsSortedByNewest = (data) => {
  if (!Array.isArray(data) || data.length === 0) return [];
  return [...data].sort((a, b) => {
    const timeA = a.resolved ?? a.timestamp;
    const timeB = b.resolved ?? b.timestamp;
    return timeB - timeA;
  });
};
